import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Covid Tracking App" link="https://sars-cov19-tracker.web.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
A website for everyone who are interested in the analytics and statistics surrounding the COVID-
19 pandemic.
    </ProjectCard>
    <ProjectCard title="Expense Management" link="https://thawing-wildwood-12359.herokuapp.com/" bg="linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,121,107,1) 58%, rgba(0,212,255,1) 100%)" mdxType="ProjectCard">
A simple daily expense tracking web application that allows individuals to monitor their spending
pattern.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      